export const FOOD_TYPES_DROPDOWN_LIST = 'FOOD_TYPES_DROPDOWN_LIST'
export const FOOD_TYPES_DROPDOWN_LIST_SUCCESS = 'FOOD_TYPES_DROPDOWN_LIST_SUCCESS'
export const FOOD_TYPES_DROPDOWN_LIST_FAILED = 'FOOD_TYPES_DROPDOWN_LIST_FAILED'

export const GET_FOOD_TYPES_DROPDOWN_ITEM = 'GET_FOOD_TYPES_DROPDOWN_ITEM'
export const GET_FOOD_TYPES_DROPDOWN_ITEM_SUCCESS = 'GET_FOOD_TYPES_DROPDOWN_ITEM_SUCCESS'
export const GET_FOOD_TYPES_DROPDOWN_ITEM_FAILED = 'GET_FOOD_TYPES_DROPDOWN_ITEM_FAILED'

export const CLEAR_FOOD_TYPES_DROPDOWN_LIST = 'CLEAR_FOOD_TYPES_DROPDOWN_LIST'
